import * as React from 'react';

import { cn } from '@/lib/util/cn';

/**
 * Skeleton placeholder. The dimensions of the skeleton MUST match the
 * dimensions of the final content to avoid layout shift — institutional
 * default for every loading boundary.
 */
export const Skeleton = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      aria-hidden
      className={cn('animate-pulse rounded-sm bg-surface-inset', className)}
      style={{ animationDuration: '1.4s' }}
      {...props}
    />
  ),
);
Skeleton.displayName = 'Skeleton';
